import { createLazyOrchestrator } from 'owa-bundling';
import { lazyLogEntityClicked } from 'owa-search-instrumentation';
import { lazyGetLocalContentId } from 'owa-search-service/lib/lazyFunctions';
import { SubstrateSearchScenario } from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import {
    KeywordSuggestion,
    PeopleSuggestion,
    Suggestion,
    SuggestionKind,
} from 'owa-search-service/lib/data/schema/SuggestionSet';
import {
    addSuggestionPill,
    startSearch,
    suggestionSelected,
    SearchScenarioId,
    lazySetIsSuggestionsDropdownVisible,
    onSearchTextChanged,
} from 'owa-search';

export const suggestionSelectedOrchestrator = createLazyOrchestrator(
    suggestionSelected,
    'CLONE_CALENDAR_SUGGESTION_SELECTED',
    async actionMessage => {
        if (actionMessage.scenarioId != SearchScenarioId.Calendar) {
            return;
        }

        const { suggestion, suggestionSetTraceId } = actionMessage;

        // Hide suggestions dropdown.
        const setIsSuggestionsDropdownVisible = await lazySetIsSuggestionsDropdownVisible.import();
        setIsSuggestionsDropdownVisible(false, SearchScenarioId.Calendar);

        switch (suggestion.kind) {
            case SuggestionKind.Keywords: {
                handleKeywordSuggestion(suggestion, suggestionSetTraceId);
                break;
            }
            case SuggestionKind.People: {
                handlePeopleSuggestion(suggestion, suggestionSetTraceId);
                break;
            }
            default:
                break;
        }
    }
);

// Log suggestion click if QF is enabled (and it's a QF suggestion)
async function logEntityClicked(
    suggestion: Suggestion,
    suggestionSetTraceId: string,
    isLocalContent?: boolean
) {
    let referenceId;
    if (isLocalContent) {
        const getLocalContentId = await lazyGetLocalContentId.import();
        referenceId = getLocalContentId(suggestion.ReferenceId);
    } else {
        referenceId = suggestion.ReferenceId;
    }

    if (suggestionSetTraceId) {
        lazyLogEntityClicked.importAndExecute(
            suggestionSetTraceId,
            referenceId,
            new Date(),
            SubstrateSearchScenario.Calendar
        );
    }
}

function handleKeywordSuggestion(suggestion: KeywordSuggestion, suggestionSetTraceId: string) {
    onSearchTextChanged(suggestion.QueryText, SearchScenarioId.Calendar);
    logEntityClicked(suggestion, suggestionSetTraceId);
    startSearch(
        'SearchBoxSuggestionDropDown',
        SearchScenarioId.Calendar,
        false /* explicitSearch */
    );
}

function handlePeopleSuggestion(suggestion: PeopleSuggestion, suggestionSetTraceId: string) {
    addSuggestionPill(suggestion, true /* suggestionSelected */, SearchScenarioId.Calendar);
    logEntityClicked(
        suggestion,
        suggestionSetTraceId,
        suggestion.Source == 'gal' /* isLocalContent */
    );
    startSearch(
        'SearchBoxSuggestionDropDown',
        SearchScenarioId.Calendar,
        false /* explicitSearch */
    );
}
